module.exports = __webpack_public_path__ + "static/media/image_check.0063eab2.svg";